import React, { useState } from "react";
import Swal from "sweetalert2";

function ExchangeRate() {
  const [value, setValue] = useState("");
  const [lastUpdate, setLastUpdate] = useState(null);

  const handleChange = (e) => {
    const inputValue = e.target.value;

    // Permite solo números y un solo punto decimal
    if (/^\d*\.?\d*$/.test(inputValue)) {
      setValue(inputValue);
    }
  };

  const historicoAlert = () => {
    // Datos simulados (luego aquí conectas backend)
    const data = [
      { monto: "18.50", usuario: "User", creado: "13/02/2026" },
      { monto: "18.30", usuario: "Admin", creado: "12/02/2026" },
      { monto: "18.75", usuario: "Sistemas", creado: "11/02/2026" },
    ];

    const tableHTML = `
      <div style="max-height:250px; overflow-y:auto;">
        <table class="table table-sm text-center">
          <thead>
            <tr>
              <th>Monto</th>
              <th>Usuario</th>
              <th>Creado</th>
            </tr>
          </thead>
          <tbody>
            ${data
              .map(
                (item) => `
              <tr>
                <td>${item.monto}</td>
                <td>${item.usuario}</td>
                <td>${item.creado}</td>
              </tr>
            `,
              )
              .join("")}
          </tbody>
        </table>
      </div>
    `;

    Swal.fire({
      title: "Histórico",
      html: tableHTML,
      width: "600px",
      confirmButtonText: "Cerrar",
      customClass: {
        confirmButton: "btn-ok",
        title: "alert-title",
        popup: "alert-bg",
      },
    });
  };

  const actualizarAlert = () => {
    if (!value) {
      Swal.fire({
        icon: "warning",
        title: "Campo requerido",
        text: "Debes ingresar un monto",
      });
      return;
    }

    Swal.fire({
      icon: "success",
      title: "Éxito",
      text: "La cantidad ha sido actualizada",
      confirmButtonText: "Aceptar",
    }).then((result) => {
      if (result.isConfirmed) {
        const now = new Date();

        // Formato bonito
        const formattedDate = now.toLocaleString("es-MX", {
          dateStyle: "short",
          timeStyle: "medium",
        });

        setLastUpdate(formattedDate);
        setValue("");
      }
    });

    // Aquí después irá la lógica real de actualización (API)
  };

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center">
      <div className="text-left">
        <div className="mb-4">
          <label className="fw-bold d-block mb-2">Tipo de cambio</label>
          <input
            type="text"
            className="form-control"
            value={value}
            onChange={handleChange}
          />
          <p className="mt-2">
            <small>
              Última actualización:{" "}
              {lastUpdate ? lastUpdate : "Sin actualizaciones"}
            </small>
          </p>
        </div>

        <div className="d-flex justify-content-center gap-3">
          <button className="btnn" onClick={historicoAlert}>
            Historial
          </button>
          <button className="btnn" onClick={actualizarAlert}>
            Actualizar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ExchangeRate;
